import queryString from 'querystring';

export const getQueryParam = (name: string): string | null => {
  const param = queryString.parse(window.location.search)[`?${name}`];
  return param ? (Array.isArray(param) ? param[0] : param) : null;
};
